module.exports = __webpack_public_path__ + "static/luminous_3-58a376a1db1b5342a26873dfd880f009.jpg";